import { c as _c } from "react/compiler-runtime";
import type { JSX } from 'react';
import type { SearchResult } from '../../../../bff/types';
import { AccountCardPreview, PolicyCardPreview } from '../components/cards';

/**
 * Helper to build the card preview in base of the result type: account or policy...
 * @param result
 * @returns JSX.Element
 */

export function RenderCardPreview(result: SearchResult, containerId?: string): JSX.Element {
  return <Card result={result} containerId={containerId} />;
}
function Card(t0) {
  const $ = _c(8);
  const {
    result,
    containerId
  } = t0;
  const {
    type,
    id,
    hasViewAccess,
    routing
  } = result;
  switch (type) {
    case "account":
      {
        const t1 = !!hasViewAccess;
        let t2;
        if ($[0] !== containerId || $[1] !== id || $[2] !== routing || $[3] !== t1) {
          t2 = <AccountCardPreview accountUuid={id} hasViewAccess={t1} routing={routing} containerId={containerId} />;
          $[0] = containerId;
          $[1] = id;
          $[2] = routing;
          $[3] = t1;
          $[4] = t2;
        } else {
          t2 = $[4];
        }
        return t2;
      }
    case "policy":
      {
        let t1;
        if ($[5] !== id || $[6] !== routing) {
          t1 = <PolicyCardPreview policyUuid={id} routing={routing} />;
          $[5] = id;
          $[6] = routing;
          $[7] = t1;
        } else {
          t1 = $[7];
        }
        return t1;
      }
    default:
      {
        return null;
      }
  }
}